module.exports = __webpack_public_path__ + "static/predefined_template_5-618b6dcee0852b5c897ecbc2576f61b8.png";